import React from "react"
import styled from "styled-components"
import { LayoutForm } from "../components/Layout"
import { CenteredWidget as Widget } from "../components/Widget"
import { OnPhone } from "../theme/MediaQueries"
import ekomi from "../images/siegel_ekomi.png"
import tuev from "../images/TUEV.svg"
import TrustItem from "../components/TrustItem"

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
`

const TrustContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f8f9fa;
  & > * {
    flex: 1;
    padding: 16px;
  }

  justify-content: space-around;
`

const Centered = () => (
  <LayoutForm>
    <PageLayout>
      <Widget />
      <OnPhone>
        <TrustContainer>
          <TrustItem image={tuev} />
          <TrustItem image={ekomi} />
        </TrustContainer>
      </OnPhone>
    </PageLayout>
  </LayoutForm>
)

export default Centered
